// src/components/cards/card-most-view.tsx
import isEmpty from 'lodash/isEmpty';
import styled from 'styled-components';
import dynamic from 'next/dynamic';
import { sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';

const Image = dynamic(import('src/components/image'));

type Props = {
  data: any;
  showTitle?: boolean;
  showCategory?: boolean;
  showBlurb?: boolean;
  eventDataLayer?: any;
  external?: boolean;
  target?: string;
  type?: 'FEATURE_IMAGE' | 'COVER_IMAGE' | 'CARD_LARGE' | 'CARD_MEDIUM' | 'CARD_SMALL' | 'NEXT_IMAGE' | string;
};

const CardMostView = ({ data, showTitle = true, showCategory = true, showBlurb = false, eventDataLayer = {}, external = false, type, target = '' }: Props) => {
  if (isEmpty(data)) return null;

  return (
    <CardWrapper className='card-most-view'>
      <a href={data?.link || data?.a || '#'} onClick={() => sendDataLayerGlobal({ ...eventDataLayer })} target={target}>
        <div className='card-thumb'>
          <Image type={type} image={data?.image} title={data?.title} decorative={Boolean(showTitle)} external={external} />
        </div>
        <div className='card-content'>
          {showTitle && <div className='title'>{data?.title}</div>}
          {showBlurb && data?.blurb && <p className='blurb'>{data?.blurb}</p>}
          {showCategory && data?.subCategory?.th && <span className='category'>{data?.subCategory?.th}</span>}
        </div>
      </a>
    </CardWrapper>
  );
};

const CardWrapper = styled.div`
  a {
    display: flex;
    gap: 15px;
    text-decoration: none;
    transition: transform 0.2s ease;
  }

  &:hover {
    a {
      transform: translateX(5px);
    }
    .title {
      color: #ed1a3b;
    }
    .card-thumb img {
      transform: scale(1.05);
    }
  }

  .card-thumb {
    flex-shrink: 0;
    width: 50%;
    aspect-ratio: 16 / 9;
    border-radius: 6px;
    overflow: hidden;
    min-width: 126px;

    .resolution-image,
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.3s ease;
    }

    @media (max-width: 768px) {
      width: 50%;
    }
  }

  .card-content {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 8px;
  }

  .title {
    color: #fff;
    font-size: 18px;
    font-weight: 500;
    line-height: 1.4;
    margin: 0;
    transition: color 0.3s ease;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;

    @media (max-width: 768px) {
      font-size: 16px;
      -webkit-line-clamp: 3;
    }
  }

  .blurb {
    color: #aaa;
    font-size: 13px;
    margin: 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .category {
    color: #ffffff;
    font-size: 14px;
    font-weight: 500;
    text-transform: uppercase;
    border-left: 2px solid #ed1a3b;
    padding-left: 5px;
    line-height: 1.5;
    @media (max-width: 768px) {
      font-size: 12px;
    }
  }
`;

export default CardMostView;
